import { useQuery, useQueryClient } from "@tanstack/react-query"
import { isFirstPagare } from "./Pagare.service"

export function useIsFirstPagare(id?: string) {
  const queryClient = useQueryClient()

  const {
    data: isFirstPagareData,
    isLoading: isFirstPagareIsLoading,
    error: isFirstPagareError,
    refetch: isFirstPagareRefetch,
  } = useQuery<boolean>({
    queryKey: ["isFirstPagare", id],
    queryFn: () => isFirstPagare(),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 2, // 2 hours
    retry: false,
  })

  const invalidateIsFirstPagare = () =>
    queryClient.invalidateQueries({ queryKey: ["isFirstPagare"] })

  return {
    isFirstPagare: isFirstPagareData,
    isFirstPagareIsLoading,
    isFirstPagareError,
    invalidateIsFirstPagare,
    isFirstPagareRefetch,
  }
}
